"use strict";

module.exports = {
  'name': 'forEach',
  'category': 'Matrix',
  'syntax': ['forEach(x, callback)'],
  'description': 'Iterates over all elements of a matrix/array, and executes the given callback function.',
  'examples': ['forEach([1, 2, 3], function(val) { console.log(val) })'],
  'seealso': ['map', 'sort', 'filter']
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/expression/embeddedDocs/function/matrix/forEach.js
// module id = 1087
// module chunks = 0